export * from './components';
export * from '@omegagrid/tree';
export * from '@omegagrid/toolbar';
export * from '@reporting/rp-app-host';

import { ComponentId } from '@omegagrid/core';
import { msg } from '@omegagrid/localize';
import { BucketPathEvent, PathSegments } from '@omegagrid/bucket';
import { AppComponent, Application, Container, parseComponentId } from '@reporting/rp-app-host';
import { Thread } from '@reporting/rp-types/deployment';
import { componentFactories } from './factories';
import { Sidebar } from './components';
import { THREAD_TYPES } from './types';

export class DeploymentApplication extends Application {

	async init(container: Container) {
		super.init(container);
		container.services.register('deployment');

		this.host.addEventListener('path.click', async (e: BucketPathEvent) => {
			if (e.path[0].id != 'deployment') return;
			const browser = ((await this.host.getComponent('deployment')) as Sidebar).browser;
			this.host.openSidebarComponent('deployment');

			if (browser.isUpdatePending) await browser.updateComplete;

			const isLeaf = e.path.length - 1 == e.index;
			let key: string;
			if (isLeaf) {
				key = `deployment-thread-${e.segment.id}`;
			} else {
				key = `${e.path.slice(0, e.index + 1).map(p => p.id).join('-')}`;
			}

			if (key) browser.tree.highlightNode(key);
		});
	}

	async resolvePath(id: ComponentId): Promise<PathSegments> {
		const parsedId = parseComponentId(id);
		const path: PathSegments = [{id: 'deployment', label: 'Deployment', clickable: true}];

		if (['tasks', 'taskForm'].includes(parsedId.ids[0] as string)) {
			path.push({id: 'tasks', label: msg('Tasks'), clickable: true});
			return path;
		}

		if (['thread', 'docEditor'].includes(parsedId.ids[0])) {
			try {
				const thread = await this.container.ms('deployment').get<Thread>(`threads/${parsedId.ids[1]}`, {
					fields: ['id_thread', 'description', 'type']
				});
				if (!thread) return [];
				path.push({id: thread.type, label: THREAD_TYPES.find(t => t.k === thread.type)?.v || '?', clickable: true});
				const threadPath = thread.description.split('/');
				threadPath.map((chunk, index) => path.push(index === threadPath.length - 1 ? {
					id: thread.id_thread.toString(),
					label: `${chunk} (#${thread.id_thread})`,
					clickable: true
				} : {
					id: chunk,
					label: chunk,
					clickable: true
				}));

				return path;
			} catch (error) {
				return [];
			}
		}
		return [];
	}

	createComponent(id: ComponentId): AppComponent|Promise<AppComponent> {
		const parsedId = parseComponentId(id);
		const factory = componentFactories.get(parsedId.id as string || parsedId.type);
		if (!factory) return null;
		return factory(this, parsedId);
	}

}
